<template>
  <div class="form_box">
    <div v-if="!isSuccess">
      <img src="../../assets/images/form3.jpg" alt="" />
      <div class="tips" v-if="formList.length > 0">
        * 如果以下没有您心目中的候选人，可找班主任新荐。
      </div>
      <form action="">
        <div class="item" v-for="(item, index) in formList" :key="item.id">
          <div class="title">
            {{ index + 1 }}. {{ item.name }}<span>{{ item.description }}</span>
          </div>
          <label v-for="option in item.candidates" :key="option.id">
            <div class="top">
              <input
                type="radio"
                :value="option.id"
                v-model="modelList[item.id]"
              />
              <div class="person">
                <div class="person_intro">
                  <img :src="option.avatar" alt="" />
                  <div class="name">
                    {{ option.name }}
                    <!-- <span v-if="option.grade">&nbsp;&nbsp;{{option.grade}}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="intro">
              <div class="person_title">{{ option.title }}</div>
              <div class="person_desc" v-html="option.description"></div>
            </div>
          </label>
          <label>
            <input type="radio" value="0" v-model="modelList[item.id]" /><span
              style="padding-left:8px;"
            ></span
            >我要弃权
          </label>
          <!-- <label class="other">
            <input type="radio" value="" v-model="modelList[item.id]">其他
            <input type="text" class="other_text" v-model="modelList[item.id]" v-show="modelList[item.id] === ''" placeholder="请输入姓名：">
          </label> -->
        </div>
      </form>
      <div class="submit" v-if="formList.length > 0">
        <input type="submit" value="提交" @click="register" />
      </div>
      <div class="copy" v-if="formList.length > 0">
        *最终解释权归高山书院所有
      </div>
    </div>
    <div class="result" v-else>
      <img src="../../assets/images/form3.jpg" alt="" />
      <!-- <div class="submitSuccess">
        <img src="../../assets/images/finish.png" alt="" class="finishlogo">
        <span>提交成功</span>
      </div> -->
      <div class="myresult">
        <div class="item" v-if="resultList.all_result">
          <div class="title">您的投票选择：</div>
          <div
            class="my_item"
            v-for="(item, index) in resultList.vote_result"
            :key="index"
          >
            {{ item.section }}：<span v-if="item.vote_student === '弃权'"
              >未投票</span
            ><span v-else>{{ item.vote_student }}</span>
          </div>
        </div>
      </div>
      <div class="allresult" v-if="resultList.all_result">
        <div class="item">
          <div class="title">
            目前得票数最多候选人
            <!-- <span style="padding-left:0;">*1月15号16点截止统计</span> -->
          </div>
          <div
            v-for="(item, index) in resultList.all_result.list"
            :key="item.id"
            style="padding-bottom:10px;"
          >
            <div class="title" style="font-size:16px;margin-top:10px;">
              {{ index + 1 }}. {{ item.section }}
            </div>
            <div
              v-for="(person, index) in item.result"
              :key="index"
              class="all"
            >
              <!-- <div v-for="(person, index) in item.result" :key="index" class="all" v-show="person.cnt === Math.max.apply(Math, item.result.map(function(o) {return o.cnt}))"> -->
              <!-- <div class="num red" v-if="index === 0">{{index + 1}}</div>
              <div class="num orange" v-if="index === 1 || index === 2">{{index + 1}}</div>
              <div class="num" v-if="index > 2">{{index + 1}}</div> -->
              <div class="all_person">
                <img
                  :src="person.vote_student_avatar"
                  alt=""
                  v-show="person.vote_student_avatar"
                />
                <div class="all_person_intro">
                  <div class="name">{{ person.vote_student_name }}</div>
                  <div class="line">
                    <div class="line_white">
                      <div
                        class="line_gray"
                        :style="
                          'width:' + (person.cnt / item.total) * 100 + '%'
                        "
                      ></div>
                    </div>
                    <div class="persent">
                      {{ Math.round((person.cnt / item.total) * 100) }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import wx from "weixin-js-sdk";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      showModal: true,
      formList: [], //投票项
      modelList: {},
      registerData: "",
      voted: false,
      jwt_token: "",
      wxlogin_token: "",
      resultList: {},
      isSuccess: false,
      voting: false
    };
  },
  created() {
    // let formId = this.$route.params.formId
    // console.log(new Date().getTime())
    // console.log(new Date('2021/1/15 12:00:00').getTime())
    this.wxlogin_token = this.$route.query.token;

    this.initWithWXCode();
  },
  methods: {
    is_weixn: function() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    goMPLoginPage: function() {
      console.log("go mp page");
      wx.miniProgram.getEnv(function(res) {
        if (res.miniprogram) {
          wx.miniProgram.navigateTo({ url: "login/login?t=vote" });
        }
      });
    },
    initWithWXCode: function() {
      let self = this;
      let req_url = `https://pyapi.gasauniversity.com/v3/agm/check/${
        this.wxlogin_token
      }`;
      // let req_url = `/v3/agm/check/${this.wxlogin_token}`
      this.$http
        .get(req_url)
        .then(function(res) {
          console.log(res);
          // 如果wxlogin code无法正确获取数据

          self.jwt_token = res.data.token;
          self.voted = res.data.voted;
          if (self.voted) {
            // 获取投票结果
            console.warn("Get vote result");
            self.refreshResult();
          } else {
            //获取投票数据
            self.getFormListData();
          }

          if (res.data.errcode == 405) {
            // 投票时间已截止
            Swal.fire({
              icon: "error",
              // title: 'Oops...',
              text: "投票时间已截止了"
            }).then(function() {
              // self.goMPLoginPage()
              console.log(res.data.errmsg);
            });
            return;
          }
          if (res.data.errcode) {
            Swal.fire({
              icon: "error",
              // title: 'Oops...',
              text: "授权无效，请重新打开页面"
              // footer: '<a href>Why do I have this issue?</a>'
            }).then(function() {
              self.goMPLoginPage();
            });
          }
        })
        .catch(function(err) {
          //alert(JSON.stringify(err))
          if (err.response.status == 404) {
            // 提示用户去微信授权
            Swal.fire({
              icon: "error",
              // title: 'Oops...',
              text: "请先输入高山书院邀请码获得投票权限"
              // footer: '<a href>Why do I have this issue?</a>'
            }).then(function() {
              self.goMPLoginPage();
            });
          }
          console.log(err);
        });
    },
    getFormListData: function() {
      let self = this;
      self.$http
        .get("https://pyapi.gasauniversity.com/v3/agm/get_candidate")
        .then(function(res) {
          console.log(res.data.data);
          self.formList = res.data.data;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    register: function() {
      // let now = new Date().getTime()
      // let end = new Date('2021/1/15 12:00:00').getTime()
      // if (true) {
      //   Swal.fire({
      //     icon: 'error',
      //     text: '评选已截止',
      //   })
      //   return
      // }
      if (this.voting) return;
      // 检查权限
      if (!this.jwt_token || this.jwt_token.length < 1) {
        Swal.fire({
          icon: "error",
          // title: 'Oops...',
          text: "您没有投票权限"
          // footer: '<a href>Why do I have this issue?</a>'
        });
        return;
      }
      // 检查选项是否都勾选
      // console.log(Object.keys(this.modelList).length, this.formList.length)
      if (Object.keys(this.modelList).length != this.formList.length) {
        Swal.fire({
          icon: "error",
          // title: 'Oops...',
          text: "有未选择的投票"
          // footer: '<a href>Why do I have this issue?</a>'
        });
        return;
      }
      let self = this;
      // console.log(self.modelList)
      try {
        self.registerData = JSON.stringify(self.modelList)
          .replace(/[\"\{\}]/g, "")
          .replace(/\,/g, ";")
          .replace(/\:/g, ",");
      } catch (err) {
        // alert(err)
      }
      // self.registerData = JSON.stringify(self.modelList)
      // .replace(/\"/g, "").replaceAll(",",";").replaceAll(":",",").replaceAll('{', '').replaceAll('}', '')
      // console.log(self.registerData)
      let post_data = {
        vote_data: self.registerData
      };
      const axios_config = {
        headers: { Authorization: `Bearer ${this.jwt_token}` }
      };

      self.voting = true;
      self.$http
        .post(
          "https://pyapi.gasauniversity.com/v3/agm/vote",
          post_data,
          axios_config
        )
        // self.$http.post('v3/agm/vote', post_data, axios_config)
        .then(function(res) {
          self.voting = false;
          self.voted = true;
          if (res.data.errcode == 405) {
            // 投票时间已截止
            Swal.fire({
              icon: "error",
              // title: 'Oops...',
              text: "投票时间已截止"
            }).then(function() {
              // self.goMPLoginPage()
              console.log(res.data.errmsg);
            });
            return;
          }
          Swal.fire({
            icon: "success",
            // title: 'Oops...',
            text: "您已投票成功"
            // footer: '<a href>Why do I have this issue?</a>'
          });
          self.refreshResult();
          self.isSuccess = true;
        })
        .catch(function(err) {
          self.voting = false;
          // alert(JSON.stringify(err))
          Swal.fire({
            icon: "error",
            // title: 'Oops...',
            text: "请稍后重试"
            // footer: '<a href>Why do I have this issue?</a>'
          });
        });
    },
    refreshResult: function() {
      let self = this;
      const axios_config = {
        headers: { Authorization: `Bearer ${this.jwt_token}` }
      };
      this.$http
        .post("https://pyapi.gasauniversity.com/v3/agm/vote", {}, axios_config)
        .then(function(res) {
          self.isSuccess = true;
          let json_result = res.data;
          //rebuild viewmodel for vote result
          self.resultList = self.buildVoteResult(json_result);
          console.log(self.resultList);
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    buildVoteResult: function(resp) {
      let voteResult = resp.all_result.list;
      voteResult.forEach((item, idx) => {
        if (item.result.length > 1) {
          let topScore = item.result[0].cnt;
          voteResult[idx].result = item.result.filter(function(vote) {
            return vote.cnt == topScore;
          });
        }
      });
      return resp;
    }
  }
};
</script>

<style lang="less" scoped>
@import "form.page.less";
</style>
<style lang="less">
.person_desc {
  p {
    margin: 0 0  3px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/form/form.page.vue